export { durationStep, durations, exitingDurations } from '../utils/durations';

export type { Durations } from '../utils/durations';
